import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { VariablesGlobales } from './variables-globales';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/operator/delay';
import 'rxjs/operator/mergeMap';
import 'rxjs/operator/switchMap';

/*
* Sirve para hacer las consultas a la API REST
*/

@Injectable()
export class Consultas {
 public constantes: VariablesGlobales;

  constructor(public http: Http) {

    console.log('Hello Consultas Provider');
  }

  getComunidadesAutonomas(){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaComunidadesAutonomas)
    .map( pueblos => pueblos.json() );
  }

  getProvinciasComunidad(idComunidad: number | string){
    let url =VariablesGlobales.urlServidor + VariablesGlobales.consultaProvinciasComunidad;
    if(idComunidad){
      url+="?id_comunidad="+idComunidad;
    }
    return this.http.get(url)
    .map( pueblos => pueblos.json() );
  }
  getProvinciasYCiudades(idComunidad: number | string){
    let url =VariablesGlobales.urlServidor + VariablesGlobales.consultaProvinciasComunidadCiudades;

    if(idComunidad){
      url+="?id_comunidad="+idComunidad;
    }

    return this.http.get(url)
    .map( pueblos => pueblos.json() );
  }

  getEmpresas(idCiudad:number,idSubcategoria:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaEmpresas +"?idC="+ idCiudad + "&idCat="+ idSubcategoria)
      .map( empresas => empresas.json() )
  }
  getEmpresa(idEmpresa:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaEmpresa+"?idE="+ idEmpresa)
    .map( empresa => empresa.json() );
  }
  getCategoriasYSubCategorias(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaCategoriasEmp+"?idCiudad=" + idCiudad)
    .map( categoriasYSubcategorias => categoriasYSubcategorias.json() );
  }
  getCategoriasYSubCategoriasByIdBarrio(idBarrio:number, idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaCategoriasEmp+"?idBarrio=" + idBarrio+"&idCiudad=" + idCiudad)
    .map( categoriasYSubcategorias => categoriasYSubcategorias.json() );
  }
  getPueblosProvincia(idProvincia:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaCiudadesProvincia+"?idProvincia="+idProvincia)
    .map( pueblos => pueblos.json() );
  }
  getPueblos(){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaCiudades)
    .map( pueblos => pueblos.json() );
  }

  getListaCategorias(idProvincia:number | string,idCiudad:number| string,idEmpresaZona:number | string, idCiudadZona:number | string){
    let url = VariablesGlobales.urlServidor + VariablesGlobales.consultaListaCategorias;
    if(idProvincia || idCiudad || idEmpresaZona || idCiudadZona){
      url+="?";
    }
    if(idProvincia){
      url+="id_provincia="+ idProvincia;
    }
    if(idCiudad){
      if(url[url.length -1] == '?'){
        url+="id_ciudad="+ idCiudad;
      }else{
        url+="&id_ciudad="+ idCiudad;
      }
    }
    if(idEmpresaZona){
      if(url[url.length -1] == '?'){
        url+="id_empresa_zona="+ idEmpresaZona;
      }else{
        url+="&id_empresa_zona="+ idEmpresaZona;
      }
    }
    if(idCiudadZona){
      if(url[url.length -1] == '?'){
        url+="id_ciudad_zona="+ idCiudadZona;
      }else{
        url+="&id_ciudad_zona="+ idCiudadZona;
      }
    }
    return this.http.get(url)
    .map( categorias => categorias.json() );
  }

  getZonasByCiudad(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaZonaCiudad+"?idPueblo="+idCiudad)
    .map( zonas => zonas.json() );
  }

  getZonasByProvincia(idProvincia:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaZonaCiudad+"?idProvincia="+idProvincia)
    .map( zonas => zonas.json() );
  }

  getZonas(){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaZonaCiudad)
    .map( zonas => zonas.json() );
  }

  getBarrios(){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaZonaEmpresas)
    .map( zonas => zonas.json() );
  }

  getBarriosByCiudad(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaZonaEmpresas+"?idPueblo="+idCiudad)
    .map( zonas => zonas.json() );
  }

  getBarriosByProvincia(idProvincia:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaZonaEmpresas+"?idProvincia="+idProvincia)
    .map( zonas => zonas.json() );
  }

  getAsociaciones(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaAsociaciones+"?idC="+ idCiudad)
    .map( asociaciones => asociaciones.json() );
  }
  getCategoriasOfertas(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaCategoriasOcio +"?sql="+ idCiudad)
    .map( categoriasOfertas => categoriasOfertas.json() );
  }
  getOfertas(idCiudad:number,idCategoria:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaOcio +"?idC="+ idCiudad+"&idCat="+idCategoria)
    .map( asociaciones => asociaciones.json() );
  }
  getAsociacionesGenerales(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaAsociacionesGenerales+"?sql="+ idCiudad)
    .map( asociacionesGenerales => asociacionesGenerales.json() );
  }
  getAsociacion(idActividad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaAsociacion+"?idA="+ idActividad)
    .map( asociacion => asociacion.json() );
  }
  getCategoriasAsociacion(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaCategoriasAso+"?sql="+ idCiudad)
    .map( categoriasAsociacion => categoriasAsociacion.json() );
  }
  getActividades(idAsociacion:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaActividades+"?idA="+ idAsociacion)
    .map( actividades => actividades.json() );
  }

  getLugares(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaLugares+"?idC="+ idCiudad)
    .map( lugares => lugares.json() );
  }
  getNoticiasGenerales(idCategoria:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaNoticiasGenerales+"?idCat="+ idCategoria)
    .map( noticias => noticias.json() );
  }
  getCategoriasNoticiasGenerales(){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaCategoriasNotiGenerales)
    .map( categoriasNoticias => categoriasNoticias.json() );
  }
  getNoticias(idCiudad:number,idCategoria:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaNoticias+"?idC="+ idCiudad+"&idCat="+idCategoria)
    .map( noticias => noticias.json() );
  }
  getCategoriasNoticias(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaCategoriasNoti +"?sql="+ idCiudad)
    .map( categoriasNoticias => categoriasNoticias.json() );
  }

  getSubCategorias(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaSubCategorias+"?sql="+ idCiudad)
    .map( subcategorias => subcategorias.json() );
  }
  getFiestas(idCiudad:number){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.consultaFiestas+"?idC="+ idCiudad)
    .map( fiestas => fiestas.json() );
  }
  getBusquedaParametrizada(idProvincia:number | string,idCiudad:number| string,idCategoria:number| string,idEmpresaZona:number | string, idCiudadZona:number | string){
    let url = VariablesGlobales.urlServidor + VariablesGlobales.consultaBusquedaParametrizada;
    if(idProvincia || idCiudad || idCategoria || idEmpresaZona || idCiudadZona){
      url+="?";
    }
    if(idProvincia){
      url+="id_provincia="+ idProvincia;
    }
    if(idCiudad){
      if(url[url.length -1] == '?'){
        url+="id_ciudad="+ idCiudad;
      }else{
        url+="&id_ciudad="+ idCiudad;
      }
    }
    if(idCategoria){
      if(url[url.length -1] == '?'){
        url+="id_categoria="+ idCategoria;
      }else{
        url+="&id_categoria="+ idCategoria;
      }
    }
    if(idEmpresaZona){
      if(url[url.length -1] == '?'){
        url+="id_empresa_zona="+ idEmpresaZona;
      }else{
        url+="&id_empresa_zona="+ idEmpresaZona;
      }
    }
    if(idCiudadZona){
      if(url[url.length -1] == '?'){
        url+="id_ciudad_zona="+ idCiudadZona;
      }else{
        url+="&id_ciudad_zona="+ idCiudadZona;
      }
    }
    return this.http.get(url)
    .map( empresas => empresas.json() );
  }
  getBusqueda(query:string,ciudades: Array<string>){
    let url = VariablesGlobales.urlServidor + VariablesGlobales.consultaBusqueda;
    let palabrasQuery = query.split(" ");
    if(palabrasQuery.includes("en") || palabrasQuery.includes("cerca")){
      palabrasQuery = palabrasQuery.filter(x => x != 'en');
      palabrasQuery = palabrasQuery.filter(x => x != 'cerca');
    }
    let queryConEspacios = palabrasQuery.join(" ");
    let queryABuscar = encodeURI(url+"?bus="+ queryConEspacios.trim());
    let querySeparadaEspacios = queryConEspacios.split(" ");

    let ciudad;
    if(ciudades){
      ciudad = querySeparadaEspacios.find((palabraBusqueda)=>{
        return ciudades.find(ciudad=> palabraBusqueda && ciudad && (palabraBusqueda.toLowerCase().includes(ciudad.toLowerCase()) || ciudad.toLowerCase().includes(palabraBusqueda.toLowerCase())));
      }
    );
    }
    //Si tengo ciudad
    if(ciudad)
    {
      let querySinCiudad = queryConEspacios;
      //Voy a quitar el ciudad de la query
      if(ciudad.includes(" ")){
        ciudad.split(" ").forEach(x=>querySinCiudad = querySinCiudad.replace(x,""));
      }
      else{
        querySinCiudad = querySinCiudad.replace(ciudad,"").trim();
      }
      //Si quedan palabras en la query está buscando la empresa también
      if(querySinCiudad.length > 1){
        let querySinConcatenacion = encodeURI(querySinCiudad.toLowerCase());
        let indiceMasFinal = querySinConcatenacion.lastIndexOf('+');
        if(indiceMasFinal!=-1)
        {
          querySinConcatenacion = querySinConcatenacion.substring(0,indiceMasFinal);
          if(querySinConcatenacion.length > 0)
            if(querySinConcatenacion[0] == '+')
              querySinConcatenacion = querySinConcatenacion.substring(1,querySinConcatenacion.length -1);
        }
        queryABuscar = encodeURI(url + "?ciudad=" + ciudad.trim()+  "&bus="+querySinConcatenacion.trim());
      }
    }

    return this.http.get(queryABuscar)
    .map( busqueda => busqueda.json() );
  }

  incrementarVisitasEmpresa(idE){
    return this.http.get(VariablesGlobales.urlServidor + VariablesGlobales.contadorVisitasEmpresa+"?idE="+idE)
    .map( resultado => resultado.json() );
  }
}



// WEBPACK FOOTER //
// ./src/providers/consultas.ts